import React from "react";

import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import List from "./List";
import Header from "./Header";
import Summary from "./Summary";

import NewModule from "../../../../layout/components/CRUD/New";
import EditAdminUserDetails from "./edit";

function AdminUsers() {
  return (
    <Routes>
      <Route
        element={
          <>
            {/* <Header /> */}
            <Outlet />
          </>
        }
      >
        <Route
          path="/list"
          element={
            <>
              <Header />

              <List />
            </>
          }
        />
        {/* <Route
          path="new-restaurant"
          element={
            <>
              <NewRestaurant />
            </>
          }
        /> */}
        {/* <Route
          path="details/*"
          element={
            <>
              <QueriesDetailsRoute className={""} />
            </>
          }
        /> */}
        {/* <Route
          path="edit-restaurant/:id"
          element={
            <>
              <EditQueriesDetails />
            </>
          }
        /> */}

        <Route
          path="new"
          element={
            <>
              <NewModule
                module={"queries"}
                modulePath="/queries"
                primary_key="_id"
              />
            </>
          }
        />
        <Route
          path="edit/:id"
          element={
            <>
              <EditAdminUserDetails />
            </>
          }
        />

        <Route path="/summary" element={<Summary />} />

        <Route index element={<Navigate to="/admin-users/list" />} />
      </Route>
    </Routes>
  );
}

export default AdminUsers;
